<div id="app-component" [@triggerName]="prepareRoute(outlet)">
    <div *ngIf="helper.mobile" id="mobile-alert" class="mensaje-mobile">
        <p>{{ 'alerta.mobile' | translate }}</p>
        <img src="assets/imgs/rotate_mobile.gif" class="d-inline-block" alt="gira el móvil" loading="lazy">
    </div>

    <app-alertas></app-alertas>
    <router-outlet #outlet="outlet"></router-outlet>
</div>
